module.exports = __webpack_public_path__ + "img/G_Sword_MaterialRdy_Greatsword.390591cd.png";